const PARAMETER_URL_PARTS = [`-is-`, `-or-`, `_special-to-`, `_special-from-`];

export const isParameterCatalogUrl = (url: string) =>
  PARAMETER_URL_PARTS.some((part) => !!url.match(part));
